import React from 'react';
import { Tooltip } from '@mui/material';

/**
 * Wraps a component with a tooltip if tooltip text is provided
 * @param children - The component to wrap
 * @param tooltip - Optional tooltip text
 * @param wrapInSpan - Whether to wrap in span for disabled tooltip support
 */
export function withTooltip<T extends React.ReactElement>(children: T, tooltip?: string, wrapInSpan = false): React.ReactElement {
  if (!tooltip) {
    return wrapInSpan ? <span>{children}</span> : children;
  }

  const wrappedChildren = wrapInSpan ? <span>{children}</span> : children;

  return (
    <Tooltip title={tooltip} arrow={false}>
      {wrappedChildren}
    </Tooltip>
  );
}
